import moment from './moment'

const ageBetween = (age, lower, upper) => {
  return lower <= age && age <=upper
}
const primeSante = (birthday, formule) => {
  let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')
  
  if (formule === "premier") {
    if (ageBetween(age, 0, 18)) return 60000
    if (ageBetween(age, 19, 30)) return 100000
    if (ageBetween(age, 31, 50)) return 150000
    if (ageBetween(age, 51, 65)) return 200000
  } else if (formule === "vitalite") {
    if (ageBetween(age, 0, 18)) return 80000
    if (ageBetween(age, 19, 30)) return 120000
    if (ageBetween(age, 31, 50)) return 170000
    if (ageBetween(age, 51, 65)) return 250000
  } else if (formule === "prestige") {
    if (ageBetween(age, 0, 18)) return 100000
    if (ageBetween(age, 19, 30)) return 150000
    if (ageBetween(age, 31, 50)) return 200000
    if (ageBetween(age, 51, 65)) return 300000
  }
  return 0
}
export const getRecap = (formule, data, primeAccidents) => {
  // Budget garanties de base
  let bgb = 0;
  for (const elem of data) {
    bgb += primeSante(elem.birthday, formule)
  }
  // Budget option Individuelle Accidents
  let boia = primeAccidents;
  // Droits d'adhésion annuels à l'APS
  let droitsAdhesion = data.length === 1 ? 10000 : 15000

  // Budget global par an
  let bga = bgb + boia + droitsAdhesion;

  // Budget global par mois
  let bgm = bga / 12;

  let familyDiscount = 0

  /*
  if (formule !== "premier") {
    // Reduction famille 
    if (data.length === 2) {
      for (const elem of data) {
        if (elem.lien === "assurePrincipal" || elem.lien === "employe") { // assurePrincipal: "Assuré principal",
          for (const item of data) {
            if (item.lien === "enfant") {
              let age = moment().diff(moment(item.birthday, "DD-MMM-YYYY"), 'years')
              if (age <= 26) {
                familyDiscount = 5
                let totalReduction = bgb * (familyDiscount/100)
                let newBgb = bgb - totalReduction
                bga = newBgb + boia + droitsAdhesion;
                familyDiscount = totalReduction
              }
            }
          }
        }
      }
    } else if (data.length > 2) { // partir de 3 beneficiaires
      for (const elem of data) {
        if (elem.lien === "assurePrincipal" || elem.lien === "employe") { // assurePrincipal: "Assuré principal",
          let nbrEnfants = 0
          let isConjoint = false // cela fait 2 parents
          let stopBoucle = false 
          for (const item of data) {
            if (stopBoucle) {
              break
            }
            if (isConjoint) {
              for (const benef of data) {
                if (benef.lien === "enfant") {
                  let age = moment().diff(moment(benef.birthday, "DD-MMM-YYYY"), 'years')
                
                  if (age <= 26) {
                    familyDiscount = 15
                    let totalReduction = bgb * (familyDiscount/100)
                    let newBgb = bgb - totalReduction
                    bga = newBgb + boia + droitsAdhesion;
                    familyDiscount = totalReduction
                    stopBoucle = true
                    break
                  }
                }
              }
            }
            if (item.lien === "conjoint") {
              isConjoint = true
            }
            if (item.lien === "enfant") {
              let age = moment().diff(moment(item.birthday, "DD-MMM-YYYY"), 'years')
              
              if (age <= 26) {
                nbrEnfants++
              }
            }
            if (nbrEnfants >= 2) {
              familyDiscount = 15
              let totalReduction = bgb * (familyDiscount/100)
              let newBgb = bgb - totalReduction
              bga = newBgb + boia + droitsAdhesion;
              familyDiscount = totalReduction
            }
          }
        }
      }
    }
  }
  */

  return {
    bgb, boia, droitsAdhesion, bga, bgm, familyDiscount
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/recapBudgetSimulation.js